/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import axios from "axios";
import config from "../config/userLists.config.json";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_PRESENTATIONS, GET_SECTION_OPTIONS } from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment-timezone";
import { pretty } from "@vlinder-web/utils-react";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ISectionOptionsMethods extends IPluginMethodMap {
  getSectionOptionsProps(args: any): Promise<any>;
  getAllSectionOptions(args: any): Promise<any>;
}

export class SectionOptionsService implements IAgentPlugin {
  readonly methods: ISectionOptionsMethods;

  constructor() {
    this.methods = {
      getSectionOptionsProps: this.getSectionOptionsProps.bind(this),
      getAllSectionOptions: this.getAllSectionOptions.bind(this),
    };
  }

  async getAllSectionOptions(args: any) {
    console.log("args getAllSectionOptions==>", pretty(args));
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const _res = await client.query({
          query: GET_PRESENTATIONS,
          variables: {
            filter: {
              status: {
                eq: "active",
              },
            },
          },
          fetchPolicy: "network-only",
        });
        let filter = {};
        if (args?.id) {
          filter = {
            section: {
              eq: args?.id,
            },
          };
        }
        filter = {
          ...filter,
          presentation: {
            eq: args?.pid
              ? args?.pid
              : _res?.data?.getPresentations?.content[0]?.id,
          },
        };
        const res = await client.query({
          query: GET_SECTION_OPTIONS,
          variables: {
            filter: filter,
          },
          fetchPolicy: "network-only",
        });

        if (res?.data) {
          return {
            sectionOptionsFilter: this.getSearchFilter(
              res?.data?.getCostumeTypes?.content
            ),
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }

  async getSectionOptionsProps(args: any) {
    console.log("args getSectionOptionsProps==>", pretty(args));
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    try {
      if (client) {
        window.open;
        const _res = await client.query({
          query: GET_PRESENTATIONS,
          variables: {
            filter: {
              status: {
                eq: "active",
              },
            },
          },
          fetchPolicy: "network-only",
        });
        let filter = {};
        if (args?.id) {
          filter = {
            ...filter,
            section: {
              eq: args?.id,
            },
          };
        }
        if (args?._id) {
          filter = {
            ...filter,
            _id: {
              eq: args?._id,
            },
          };
        }
        filter = {
          ...filter,
          presentation: {
            eq: args?.pid
              ? args?.pid
              : _res?.data?.getPresentations?.content[0]?.id,
          },
        };
        const res = await client.query({
          query: GET_SECTION_OPTIONS,
          variables: {
            filter: filter,
            options: {
              limit: args?.size ?? 10,
              skip: args?.offset ?? 0,
            },
          },
          fetchPolicy: "network-only",
        });

        if (res?.data) {
          let _totalPages = res?.data?.getCostumeTypes?.count
            ? Math.ceil(parseInt(res?.data?.getCostumeTypes?.count) / 10)
            : 1;

          let _currentPage =
            res?.data?.getCostumeTypes?.skip /
            res?.data?.getCostumeTypes?.limit +
            1;
          let _rowData = this.formatTable(res?.data?.getCostumeTypes?.content);
          let _rowDataTotal = this.getTotal(res?.data?.getCostumeTypes?.content);
          console.log("_rowData==>", _rowDataTotal[0]?.limitTotal)
          return {
            ...config,
            ultUsers: _rowData,
            limitTotal: _rowDataTotal[0]?.limitTotal ?? 0,
            remainingTotal: _rowDataTotal[0]?.remainingTotal ?? 0,
            registeredTotal: _rowDataTotal[0]?.registeredTotal ?? 0,
            isEmpty: res?.data?.getCostumeTypes?.content?.length <= 0,
            activePage: _currentPage,
            currentPage: _currentPage,
            pageSize: _rowData.length,
            totalCount: res?.data?.getCostumeTypes?.count,
            totalPages: _totalPages,
            sectionOptionsFilter: this.getSearchFilter(
              res?.data?.getCostumeTypes?.content
            ),
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
  private getSearchFilter(costumeTypes: any[]): any[] {
    let _rowData: any = [];
    costumeTypes.forEach((item) => {
      _rowData.push({
        label: item.name,
        value: item.id,
      });
    });
    return _rowData;
  }
  private formatTable(costumeTypes: any[]): any[] {
    let _rowData: any = [];
    costumeTypes.forEach((item) => {
      _rowData.push({
        sectionName: item?.section?.name ?? "Null",
        sectionOptionName: item?.name ?? "Null",
        id: item?.id,
        defultInvitesUsed: item?.inventoryDetail?.defaultInvitesUsed,
        sectionSpecificInvitesUsed:
          item?.inventoryDetail?.sectionSpecificInvitesUsed,
        specialInvitesUsed: item?.inventoryDetail?.specialInvitesUsed,
        defaultInvitesRemaining: item?.inventoryDetail?.defaultInvitesRemaining,
        sectionSpecificInvitesRemaining:
          item?.inventoryDetail?.sectionSpecificInvitesRemaining,
        specialInvitesRemaining: item?.inventoryDetail?.specialInvitesRemaining,
        historyArray: item?.updateHistory ?? [],
        inventory:
          item?.inventory ??
          (item?.sectionSpecificInvites ?? 0) +
          (item?.defaultInvites ?? 0) +
          (item?.specialInvites ?? 0),
        registered:
          item?.inventoryDetail?.defaultInvitesUsed +
          item?.inventoryDetail?.sectionSpecificInvitesUsed +
          item?.inventoryDetail?.specialInvitesUsed,
        remaining:
          item?.inventoryDetail?.defaultInvitesRemaining +
          item?.inventoryDetail?.sectionSpecificInvitesRemaining +
          item?.inventoryDetail?.specialInvitesRemaining,
        sectionSpecificInvites: item?.sectionSpecificInvites,
        defaultInvites: item?.defaultInvites,
        specialInvites: item?.specialInvites,
      });
    });
    //645dd349a4982a5b9567244f

    return _rowData;
  };

  private getTotal(costumeTypes: any[]): any[] {
    let _rowData: any = [];
    let result: any = [];
    costumeTypes.forEach((item) => {
      _rowData.push({
        inventory:
          item.inventory ??
          (item.sectionSpecificInvites ?? 0) +
          (item.defaultInvites ?? 0) +
          (item.specialInvites ?? 0),
        registered:
          item.inventoryDetail.defaultInvitesUsed +
          item.inventoryDetail.sectionSpecificInvitesUsed +
          item.inventoryDetail.specialInvitesUsed,
        remaining:
          item.inventoryDetail.defaultInvitesRemaining +
          item.inventoryDetail.sectionSpecificInvitesRemaining +
          item.inventoryDetail.specialInvitesRemaining,
      });
    });
    let sumInventory = 0;
    let sumRegistered = 0;
    let sumRemaining = 0;

    for (const item of _rowData) {
      sumInventory += item.inventory;
      sumRegistered += item.registered;
      sumRemaining += item.remaining;
    }
    result.push({
      limitTotal: sumInventory,
      registeredTotal: sumRegistered,
      remainingTotal: sumRemaining
    })
    console.log("_rowData==>", pretty(result));
    return result;
  }
}
